/* eslint-disable */
import React, {useState,useRef,useEffect} from 'react';
import Modal from 'react-modal';
import Dropdown from "./Dropdown";
import styled from 'styled-components';
import Svg from "_assets/svg";
import Close from "_assets/images/close.png";
const Icon = styled.img``;
import { Alert,AlertType } from "utils/Alert";

// Services
import generateReportSvc from "services/generateReportSvc";
import applicationSvc from "services/applicationSvc";
import { today, yesterday, weekEnd, monthStart, formatDate } from 'utils/dateFormat';

// library
import { DateRangePickerComponent,PresetsDirective, PresetDirective  } from '@syncfusion/ej2-react-calendars';
import moment from "moment";
import MultipleSelectStatus from './multiple-select';
import { statusWa, statusCall, statusEmail, statusSMS, statusSMSOTP, statusVoiceOTP } from "./listStatusReport";

// Modal.setAppElement('#root');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ButtonProject = styled.div`
  /* Rectangle 99 */
  // margin: 8px;

  // padding: 10px;
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
  align-items: center;

  background: #f8f8f9;
  opacity: 0.8;
  border: 1px solid #d8dce1;
  box-sizing: border-box;
  border-radius: 8px;
  &:focus{
    outline: none;
  }

  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  cursor:pointer;
`;

function ModalGenerate(props) {
  const {isOpenModal,setOpenModal,refreshData} = props;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [dropdownType, setDropdownType] = useState(false);
  const [isSelectedChannel, setSelectedChannel] = useState('');
  const [isSelectedType, setSelectedType] = useState('');
  const [isListStatus, setListStatus] = useState([]);
  const [isTitle, setTitle] = useState('');
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [isTextDate, setTextDate] = useState("Select date...")
  const [isDataApplication, setDataApplication] = useState([])
  const initialValidation = {
    start_date: { isValid: true, msg: "" },
    end_date: { isValid: true, msg: "" },
    title: { isValid: true, msg: "" },
    status: { isValid: true, msg: "" },
    channel: { isValid: true, msg: "" },
    type: { isValid: true, msg: "" },
  };
  const [isErrorValidation, setErrorValidation] = useState(initialValidation)
  const [isFinalStatus, setFinalStatus] = useState([]);
  const [dataStatusAll, setDataStatusAll] = useState(null)
  const [isLoadingGenerate, setLoadingGenerate] = useState(false);

  const listDownloadType = [
    {
      name:'.CSV',
      value:'csv'
    },
    {
      name:'.XLS',
      value:'xlsx',
    }
  ]
  
  const listChannel = [
    {
      name:'Whatsapp',
      value:'whatsapp'
    },
    {
      name:'SMS',
      value:'sms',
    },
    {
      name:'Email',
      value:'email',
    },
    {
      name:'Voice',
      value:'voice',
    },
    {
      name:'Voice OTP',
      value:'call-otp',
    },
    {
      name:'SMS OTP',
      value:'sms-otp',
    },
  ]
  
  useEffect(()=>{
    if(isSelectedChannel.value == 'whatsapp'){
      setListStatus(statusWa)
    } else if(isSelectedChannel.value == 'sms'){
      setListStatus(statusSMS)
    } else if(isSelectedChannel.value == 'sms-otp'){
      setListStatus(statusSMSOTP)
    } else if(isSelectedChannel.value == 'call-otp'){
      setListStatus(statusVoiceOTP)
    } else if(isSelectedChannel.value == 'email'){
      setListStatus(statusEmail)
    } else if(isSelectedChannel.value == 'voice'){
      setListStatus(statusCall)
    }

  },[isSelectedChannel])

  useEffect(()=>{
    getAllData();
  }, [])
  

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setOpenModal(false)
  }

  function handleValidation(){
    let validationForm = initialValidation;
    if (!isTitle) {
      validationForm = {
        ...validationForm,
        title: { ...validationForm.title, isValid: false, msg: "Report Name is Required" },
      };
    }

    if (isFinalStatus.length < 1) {
      validationForm = {
        ...validationForm,
        status: { ...validationForm.status, isValid: false, msg: "Status is Required" },
      };
    }

    if (!isSelectedType) {
      validationForm = {
        ...validationForm,
        type: { ...validationForm.type, isValid: false, msg: "Type is Required" },
      };
    }

    if (!isSelectedChannel) {
      validationForm = {
        ...validationForm,
        channel: { ...validationForm.channel, isValid: false, msg: "Channel is Required" },
      };
    }
    
    if (startDate === "" || endDate === "") {
      validationForm = {
        ...validationForm,
        start_date: { ...validationForm.start_date, isValid: false, msg: "Date is required" },
      };
    }

    setErrorValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
      console.log(key)
    });
    return result;
  }
  
  async function handleGenerateReport(){
    if(!handleValidation()){
      return;
    }
   
    let reqBody = {
      "application_id": isDataApplication,
      "title":isTitle,
      "channel": isSelectedChannel?.value,
      "status": dataStatusAll ? [] : isFinalStatus,
      "start_date": startDate,
      "end_date": endDate,
      "type": isSelectedType?.value,
      "search": ""
  }

  setLoadingGenerate(true)
    try {
      let data = await generateReportSvc.generateNewReport(reqBody)
      if(data){
        refreshData()
        closeModal()
        refreshForm()
        Alert.showStatus(
          AlertType.SUCCESS,
          'Success!',
          'Success! A new report has been generated!'
        )
      }
    setLoadingGenerate(false)
    } catch (error) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        error.message
      )
      setLoadingGenerate(false)
    }
  }

  const getAllData = async () => {
    try {
      const applicationData = await applicationSvc.getAll();
      setDataApplication(applicationData?.data?.data[0]._id)
    } catch (err) {
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        err.message
      )
    }
  };

  let dateRange = useRef()
  function handleClickDate(value){
      dateRange?.current?.show()
  }

  function handleOnchangeDate(value) {
    if (value.value ) {
      setStartDate(moment(value.value[0]).format("YYYY-MM-DD"));
      setEndDate(moment(value.value[1]).format("YYYY-MM-DD"));

      setTextDate(formatDate(new Date(value.value[0])) + ' - ' + formatDate(new Date(value.value[1])))

    }else{
      setStartDate("");
      setEndDate("")
    }
  }

  function resetDate(){
    setStartDate("")
    setEndDate("")
    setTextDate('Select date...');
  }

  function refreshForm(){
    setStartDate("")
    setEndDate("")
    setTextDate('Select date...');
    setTitle('');
    setSelectedType('')
    setListStatus([])
    setSelectedChannel('')
  }

  function handleSetReportName(e) {
    setTitle(
      e
      .replace(/ /g, "_")
      .replace(/[^a-zA-Z0-9_]/g, "")
      .toLowerCase()
    );
  } 

  return (
    <div>
      <div>
      <Modal
        isOpen={modalIsOpen || isOpenModal}
        onRequestClose={openModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className='d-flex justify-content-between flex-column' style={{height:'unset',width:'50vw'}}>
          <div>
          <h2 className="margin-bottom-10 title-modal">Generate Report</h2>
          <div className='d-flex justify-content-between'>
            <div className='col-6' style={{paddingRight:'10px'}}>
              <div className='mb-4' style={{position:'relative'}}>
                <label className="margin-bottom-5 h4 margin-right-10">Report Name <span className='startRed'>*</span></label>
                <div className='input-group'>
                <input
                  required={true}
                  start={true}
                  title="Report Name"
                  id="report_name"
                  label="report_name"
                  type="text"
                  placeholder="Input report name"
                  error=""
                  className='form-control'
                  value={isTitle}
                  // onChange={(e) => setTitle(e.target.value)}
                  onChange={(e) => handleSetReportName(e.target.value)}
                />
                </div>
                <div className='startRed italic'>{isErrorValidation?.title?.msg}</div>
              </div>
              <div className='mb-4' style={{position:'relative'}}>
                <label className="margin-bottom-5 h4 margin-right-10">Select channel <span className='startRed'>*</span></label>
                <ButtonProject className="w-auto col-md-6 br-8" onClick={() => { setDropdown(!dropdown) }}>
                  <label className="margin-right-10">{isSelectedChannel ? isSelectedChannel.name :'Select channel'}</label>
                  <Icon src={Svg.chevron_right_2.default} />
                </ButtonProject>
                {dropdown && <Dropdown data={listChannel} handleClick={(i) => { setSelectedChannel(i); setDropdown(false);}} />}
                <div className='startRed italic mb-2'>{isErrorValidation?.channel?.msg}</div>
              </div>
              <MultipleSelectStatus title={"Status"} dataFilt={isListStatus} setFinalStatus={setFinalStatus} validation={isErrorValidation?.status?.msg} setDataStatusAll={setDataStatusAll}></MultipleSelectStatus>
            </div>
            <div className='col-6' style={{paddingLeft:'10px'}}>
              <div className='mb-4' style={{position:'relative'}}>
                <label className="margin-bottom-5 h4 margin-right-10">Select Download Type <span className='startRed'>*</span></label>
                <ButtonProject className="w-auto col-md-6 br-8" onClick={() => { setDropdownType(!dropdownType) }}>
                  <label className="margin-right-10">{isSelectedType ? isSelectedType.name :'Select Download Type'}</label>
                  <Icon src={Svg.chevron_right_2.default} />
                </ButtonProject>
                {dropdownType && <Dropdown data={listDownloadType} handleClick={(i) => { setSelectedType(i); setDropdownType(false);}} />}
                <div className='startRed italic mb-2'>{isErrorValidation?.type?.msg}</div>
              </div>
              <div className='custom-ej2date datepicker-control-section mb-3'>
                <label className="margin-bottom-5 h4 margin-right-10">Select Range<span className='startRed'>*</span></label>
                  <DateRangePickerComponent
                  delayUpdate={true}
                  ref={(scope)=>{dateRange.current = scope}}
                  enableRtl={true}
                  className='custom-ej2date'   
                  change={handleOnchangeDate}
                  minDays={1} 
                  maxDays={31}
                  // onClick={handleClickDate}
                  placeholder='Choose date'>
                    <PresetsDirective>
                        <PresetDirective label="Today" start={today} end={today}></PresetDirective>
                        <PresetDirective label="Yesterday" start={yesterday} end={today}></PresetDirective>
                        <PresetDirective label="Last 7 Days" start={weekEnd} end={today}></PresetDirective>
                        <PresetDirective label="Last 30 Days" start={monthStart} end={today}></PresetDirective>
                        {/* <PresetDirective label="Last Month" start={lastStart} end={lastEnd}></PresetDirective> */}
                        {/* <PresetDirective label="Last Year" start={yearStart} end={yearEnd}></PresetDirective> */}
                    </PresetsDirective>
                  </DateRangePickerComponent>
                  <div className="form-control wrap-date-ejs custom_ejs">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.25 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V9H15V14.25ZM15 7.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V7.5Z" fill="#42526E"/>
                    </svg>
                    <input
                    style={{width:'80%',cursor:'pointer'}} 
                      type="text" 
                      className='w-full input-time-custom cursor-pointer ms-2'
                      onClick={handleClickDate}
                      value={isTextDate}
                      required="required"
                      placeholder="placetext"/>
                      {
                        isTextDate !== 'Select date...' &&
                        <img className='ic-reset pinkic-hover' onClick={resetDate} src={Close}></img>
                      }
                  </div>
                  <div className='startRed italic mb-2'>{isErrorValidation?.start_date?.msg}</div>
              </div>
            </div>
          </div>
          </div>
          <div className='d-flex align-items-center justify-content-end'>
            <div onClick={closeModal} className='me-3 btn-secondary'>
              <h5 className="fw-bold btn-generate">
                Close
              </h5>
            </div>
            <div disabled={isLoadingGenerate} onClick={handleGenerateReport} className='btn-generate-report'>
              <h5 className="fw-bold btn-generate">
                Done
              </h5>
            </div>
          </div>
        </div>
      </Modal>
      </div>
    </div>
  )
}

export default ModalGenerate;